<template>
  <SingleStory
    :storyContent="activeStoryContent"
    :isPlaying="isPlaying"
    :activeEpisode="activeEpisode"
  />
</template>

<script>
import SingleStory from '../components/SingleStory'

export default {
  metaInfo: {
    titleTemplate: '%s | Beyond School',
  },
  data () {
    return {
      activeStoryContent: {}
    }
  },
  props: {
    isPlaying: Boolean,
    activeEpisode: String
  },
  components: {
    SingleStory
  },
  created() {
    this.activeStoryContent = require(`@/stories/${this.$route.name}.json`)
  },
  watch: {
    $route() {
      this.activeStoryContent = require(`@/stories/${this.$route.name}.json`)
    }
  }
}
</script>